import { DOT_SYMBOL } from '../../constants/constants';
export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};
export var getSubHeading = (mobileNumber, simProvider, upcCode, subHeading) => {
  if (subHeading) {
    return subHeading;
  }
  return mobileNumber + " " + DOT_SYMBOL + " " + upcCode + " " + DOT_SYMBOL + " " + simProvider;
};
export var validateInputField = formData => {
  if (!formData) return false;
  var _formData$value = formData.value,
    value = _formData$value === void 0 ? '' : _formData$value,
    fieldState = formData.state,
    showLoader = formData.showLoader,
    validationRegex = formData.validationRegex;
  var isError = fieldState === 'error';
  var isLoading = showLoader === true;
  var isValid = !isError && !isLoading;
  if (typeof validationRegex === 'string') {
    var isValidRegex = new RegExp(validationRegex).test(value);
    isValid = isValid && isValidRegex;
  }
  return isValid;
};